import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import "/home/jenkins/agent/workspace/usedcar-vue-mobile-uat-frontend/node_modules/core-js/modules/es.array.iterator.js";
import "/home/jenkins/agent/workspace/usedcar-vue-mobile-uat-frontend/node_modules/core-js/modules/es.promise.js";
import "/home/jenkins/agent/workspace/usedcar-vue-mobile-uat-frontend/node_modules/core-js/modules/es.object.assign.js";
import "/home/jenkins/agent/workspace/usedcar-vue-mobile-uat-frontend/node_modules/core-js/modules/es.promise.finally.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
// 兼容 IE
// https://github.com/zloirock/core-js/blob/master/docs/2019-03-19-core-js-3-babel-and-a-look-into-the-future.md#babelpolyfill
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/aMap';
import Stroage from 'vue-ls';
import { $cdn } from '@/config';
import moment from 'moment'; // moment挂载
import PDF from 'vue-pdf';
import constants from './utils/constants';
import VConsole from 'vconsole/dist/vconsole.min.js';
import '@/svgIcon/index.js';
import { setTheme, themeMap, isVersion4 } from './utils/commonUtils';
import { eventListen } from './utils/cordova-index';
import VueClipBoard from 'vue-clipboard2';
Vue.prototype.Constants = constants;
import akd from '@zeekr-fe/akd-lynkco';
import { akdConfig } from '../ak-config/akd-config.js';
// 初始化 SDK（只需调用一次）
akd.init(akdConfig);
var options = {
  namespace: '',
  // key键前缀
  name: 'ls',
  // 命名Vue变量.[ls]或this.[$ls],
  storage: 'local' // 存储名称: session, local, memory
};
Vue.use(_Dialog);
Vue.use(Stroage, options);
Vue.use(PDF);
Vue.use(VueClipBoard);
if (process.env.NODE_ENV === 'development') {
  Vue.prototype.$vconsole = new VConsole();
}
// Vue.use(weex)

// 设置 js中可以访问 $cdn

Vue.prototype.$cdn = $cdn;
Vue.prototype.$moment = moment;
moment.locale('zh-cn');

// 全局引入按需引入UI库 vant
import '@/plugins/vant';
// 引入全局样式
import '@/assets/css/index.scss';
// 移动端适配
import 'lib-flexible/flexible.js';

// filters
import './filters';
import './style/theme.scss';
Vue.config.productionTip = false;
var app = new Vue({
  el: '#app',
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  },
  data: {
    eventHub: new Vue()
  }
});
// 判断是否 iOS
var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

// 动态添加 class
if (isIOS) {
  document.body.classList.add('body-ios');
}
if (window) window.SWEEXAPP = new Vue();
import '@/assets/font-type/lynkco-font-type.css';

//  监听端上主题切换事件
var initThemeEvent = function initThemeEvent() {
  console.log('initThemeEvent');
  eventListen('sw_event_theme_changed', function (res) {
    console.log('-sw_event_them_changed', res);
    setTheme(res.data.themeStyle);
  });
};
var init = function init() {
  setTheme();
};
if (window.navigator.userAgent.indexOf('x-cordova') > -1) {
  document.addEventListener('deviceready', function () {
    init();
    window.LYNKAPP = app;
    initThemeEvent();
  });
}